export const getLocalTimezone = (date: string): string =>
  new Intl.DateTimeFormat("default", { timeZoneName: "short" })
    .formatToParts(new Date(date))
    .find((part) => part.type === "timeZoneName")!.value;
